export const ADMIN = 'ADMIN';
export const ADMIN_SECONDARY = 'ADMIN-SECONDARY';
export const SELLER = 'SELLER';

export const SUPER_ADMIN_ONUS = 'SUPER-ADMIN-ONUS';
export const ADMIN_ONUS = 'ADMIN-ONUS';
export const ANALISTA_ONUS = 'ANALISTA-ONUS';

export const VERIFY_EMAIL = 'VERIFY EMAIL';
export const UNSUBSCRIBE = 'UNSUBSCRIBE';
export const APPROVED = 'APPROVED';
export const DELETED = 'DELETED';

export const USER_STATUS = {
  VERIFY_EMAIL,
  UNSUBSCRIBE,
  APPROVED,
  DELETED,
};

export const STATUS_LIST_PRIORITY = {
  'VERIFY EMAIL': 1,
  UNSUBSCRIBE: 2,
  APPROVED: 3,
  DELETED: 4,
};

export const ROLES_LIST_PRIORITY = {
  'Representante Legal': 1,

  ADMIN: 2,
  'ADMIN-SECONDARY': 3,
  SELLER: 4,

  'SUPER-ADMIN-ONUS': 2,
  'ADMIN-ONUS': 3,
  'ANALISTA-ONUS': 4,
};

export const docTypesChile = [{ text: 'RUT', value: 'RUT' }];
export const docTypesPeru = [
  // { text: 'RUC', value: 'RUC' },
  { text: 'DNI', value: 'DNI' },
  { text: 'CE', value: 'CE' },
  { text: 'Pasaporte', value: 'pas' },
];
export const docTypesColombia = [
  { text: 'CC', value: 'CC' },
  { text: 'CE', value: 'CE' },
  { text: 'PAS', value: 'PAS' },
];
